import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import { Grid } from '@mui/material';
import { Trans, useTranslation } from 'react-i18next';
import {
    FormControl,
    MenuItem,
} from '@mui/material';
import { useContext, useEffect, useState } from 'react';
import { langService } from 'src/services';
import { ActionContext } from 'src/contexts/ActionContext';
import { CURRENT_USER } from 'src/constants';
import { User } from 'src/models/user/user.model';
export default function DialogChoiceLangSf(props) {
    const { t, i18n } = useTranslation();
    const userData: User = JSON.parse(localStorage.getItem(CURRENT_USER));
    const {
        currentIdUserDc,
        currentIdLangUserDc,
        setCurrentIdLangUserDc
    } = useContext(ActionContext);
    const [allLang, setAllLang] = useState([{
        langId: 0,
        langCode: '',
        langName: '',
        langSort: 0
    }])

    useEffect(() => {
        langService.getAll().then(response => {
            if (response.data.success) {
                setAllLang(response.data.data)
            }
        });
    }, []);

    const saveLang = () => {
        langService.changeUserLang(currentIdUserDc, currentIdLangUserDc).then(response => {
            if (response.data.success && response.data.data) {
                if (currentIdLangUserDc == 2 && !window.location.pathname.includes("page/dc/create")) {
                    if (currentIdUserDc == userData.id) {
                        window.location.href = '/page/dc/menu'
                    } else {
                        window.location.href = '/management/collaborateur'
                    }
                } else {
                    if (currentIdLangUserDc == 2 && window.location.pathname.includes("page/dc/create")) {
                        window.location.href = "/page/dc/create/" + currentIdUserDc + "/2";
                    } else if (currentIdLangUserDc != 2 && window.location.pathname.includes("page/dc/create")) {
                        window.location.href = "/page/dc/create/" + currentIdUserDc + "/1";
                    } else {
                        window.location.reload();
                    }
                }
            }
        });
    }
    const handleChange = (e) => {
        setCurrentIdLangUserDc(e.target.value);
    }
    return (
        <>
            <Dialog open={props.open} maxWidth={'sm'} fullWidth>
                <DialogTitle style={{ fontSize: 20, paddingBottom: 0 }}>
                    <span>
                        <Trans>dc.SFLanguage.dialogTitle</Trans>
                    </span>
                </DialogTitle>
                <DialogContent style={{ paddingBottom: 5, paddingTop: 10 }}>
                    <form>
                        <Grid container direction="row" alignItems="stretch" spacing={1} >
                            <Grid item xs={12}>
                                <FormControl fullWidth >
                                    <TextField
                                        select
                                        name="lang"
                                        value={currentIdLangUserDc}
                                        onChange={handleChange}
                                        label={t('dc.SFLanguage.dialogLabel')}
                                    >
                                        {allLang.map((option, index) => (
                                            <MenuItem key={option.langId} value={option.langId}>
                                                <img alt={option.langCode} src={"/static/images/flags/lang_" + option.langId + ".png"} style={{ width: 18, height: 12 }} />
                                                &nbsp;{option.langName}
                                            </MenuItem>
                                        ))}
                                    </TextField>
                                </FormControl>
                            </Grid>
                        </Grid>
                    </form>
                    <div style={{ paddingTop: 10 }}>
                        <Button variant="contained"
                            onClick={saveLang}>
                            <Trans>button.save</Trans>
                        </Button>
                        <Button
                            style={{ marginLeft: 5 }}
                            variant="contained"
                            color="error"
                            onClick={props.handleClose}>
                            <Trans>button.cancel</Trans>
                        </Button>
                    </div>
                    <p><Trans>dc.SFLanguage.dialogContent</Trans></p>
                    <p><Trans>dc.SFLanguage.dialogContentText</Trans></p>
                </DialogContent>
            </Dialog>
        </>
    );
}